import LocalStrings from '../../assets/languages';
import { ALLOWED_FEATURE_KEYS } from './common-constants';

export const ALLOWED_APP_THEMES = {
  types: ['auto', 'light', 'dark'],
  options: [
    { value: 'auto', text: LocalStrings.dynamic.kAuto },
    { value: 'light', text: LocalStrings.dynamic.kLightMode },
    { value: 'dark', text: LocalStrings.dynamic.kDarkMode }
  ],
  auto: 'auto',
  light: 'light',
  dark: 'dark'
};

export const ALLOWED_REPORTED_CONTENT_TYPES = {
  community: {
    post: 'community_post',
    comment: 'community_comment'
  },
  gallery: {
    post: 'gallery_post',
    comment: 'gallery_comment'
  },
  social: {
    post: 'social_post',
    comment: 'social_comment'
  },
  liveqa: {
    post: 'liveqna_post',
    comment: 'liveqna_comment'
  },
  schedule: {
    comment: 'session_comment'
  }
};

export const ALLOWED_REPORTED_CONTENT_STRUCTURE = {
  community: { post: [], comment: [] },
  gallery: { post: [], comment: [] },
  social: { post: [], comment: [] },
  liveqa: { post: [], comment: [] },
  schedule: { comment: [] }
};

export const REPORT_CONTENT_PAYLOAD_STRUCTURE = {
  eventid: null,
  type: '',
  typeid: '',
  reported_by: ''
};

export const ALLOWED_NOTIFICATION_TYPES = {
  outreach: 'outreach',
  session: 'session'
};

export const ALLOWED_SCHEDULE_VIEWS = {
  types: ['grid', 'time', 'calendar'],
  grid: 'grid', // track
  time: 'time',
  calendar: 'calendar',
  options: [
    {
      value: 'grid',
      text: LocalStrings.dynamic.kShowByTracks
    },
    {
      value: 'time',
      text: LocalStrings.dynamic.kShowByTime
    },
    {
      value: 'calendar',
      text: LocalStrings.dynamic.kShowAsCalendar
    }
  ]
};

export const SCHEDULE_LOCALSTORAGE_STRUCTURE = {
  userWantsConvertedTime: false,
  userInEventTimeZone: false,
  userUpdatedTZ: false,
  userUpdatedView: false,
  view: ALLOWED_SCHEDULE_VIEWS.grid
};

// Keys are defined and used to understand the cases, values are less important
export const ALLOWED_CONNECTION_TYPES = {
  request: 1,
  requested: 2,
  acceptReject: 3,
  allowed: 4
};

export const ALLOWED_BOOKMARK_TYPES = [
  {
    title: LocalStrings.dynamic.kSpeakerText,
    type: ALLOWED_FEATURE_KEYS.speaker,
    key: ALLOWED_FEATURE_KEYS.speaker,
    isenabled: true
  },
  {
    title: LocalStrings.dynamic.kSessionText,
    type: ALLOWED_FEATURE_KEYS.schedule,
    key: ALLOWED_FEATURE_KEYS.schedule,
    isenabled: true
  },
  {
    title: LocalStrings.dynamic.kSponsorText,
    type: ALLOWED_FEATURE_KEYS.sponsor,
    key: ALLOWED_FEATURE_KEYS.sponsor,
    isenabled: true
  },
  {
    title: LocalStrings.dynamic.kExhibitorText,
    type: ALLOWED_FEATURE_KEYS.exhibitor,
    key: ALLOWED_FEATURE_KEYS.exhibitor,
    isenabled: true
  },
  {
    title: LocalStrings.dynamic.kNewsText,
    type: ALLOWED_FEATURE_KEYS.news,
    key: ALLOWED_FEATURE_KEYS.news,
    isenabled: true
  },
  {
    title: LocalStrings.dynamic.kAttendeesText,
    type: 'user',
    key: ALLOWED_FEATURE_KEYS.attendee,
    isenabled: true
  }
];

export const RESTRICTED_REGISTRATION_BUTTON_EVENT_POLICIES = [
  'public_without_reg',
  'sold_out',
  'no_registration'
];

export const ALLOWED_REGISTRATION_BUTTON_EVENT_POLICIES = [
  'public_with_reg',
  'public_with_ticket',
  'external_registration_link'
];

// NOTE: DO NOT ALLOW `underscore` as type as webview items are coning as `webview_<apptabid>` format
export const ALLOWED_OVERVIEW_ITEMS = {
  countdown: 'countdown',
  suggestedContact: 'suggestedcontact',
  completeProfile: 'completeprofile',
  userinterests: 'userinterests',
  newMessage: 'newmessage',
  quicklinks: 'quicklinks',
  promoteYourself: 'promoteyourself', // user as speaker
  promoteAttendee: 'promoteattendee',
  promoteExhibitor: 'promoteexhibitor',
  schedule: ALLOWED_FEATURE_KEYS.schedule,
  meetings: ALLOWED_FEATURE_KEYS.meetings,
  exhibitor: ALLOWED_FEATURE_KEYS.exhibitor,
  sponsor: ALLOWED_FEATURE_KEYS.sponsor,
  speaker: ALLOWED_FEATURE_KEYS.speaker,
  maps: ALLOWED_FEATURE_KEYS.maps,
  social: ALLOWED_FEATURE_KEYS.social,
  news: ALLOWED_FEATURE_KEYS.news,
  gamification: ALLOWED_FEATURE_KEYS.gamification,
  about: 'about',
  ads: 'ads'
};

export const OVERVIEW_ITEMS_EXTRA = [
  ALLOWED_OVERVIEW_ITEMS.countdown,
  ALLOWED_OVERVIEW_ITEMS.suggestedContact,
  ALLOWED_OVERVIEW_ITEMS.completeProfile,
  ALLOWED_OVERVIEW_ITEMS.userinterests,
  ALLOWED_OVERVIEW_ITEMS.newMessage,
  ALLOWED_OVERVIEW_ITEMS.quicklinks,
  ALLOWED_OVERVIEW_ITEMS.promoteYourself,
  ALLOWED_OVERVIEW_ITEMS.promoteAttendee,
  ALLOWED_OVERVIEW_ITEMS.about,
  ALLOWED_OVERVIEW_ITEMS.ads
];

export const OVERVIEW_ITEMS_ALLOWED_AFTER_LOGIN = [
  ALLOWED_OVERVIEW_ITEMS.suggestedContact,
  ALLOWED_OVERVIEW_ITEMS.completeProfile,
  ALLOWED_OVERVIEW_ITEMS.userinterests,
  ALLOWED_OVERVIEW_ITEMS.newMessage,
  ALLOWED_OVERVIEW_ITEMS.quicklinks,
  ALLOWED_OVERVIEW_ITEMS.promoteYourself,
  ALLOWED_OVERVIEW_ITEMS.promoteAttendee,
  ALLOWED_OVERVIEW_ITEMS.promoteExhibitor,
  ALLOWED_OVERVIEW_ITEMS.meetings,
  ALLOWED_OVERVIEW_ITEMS.social
];

export const ALLOWED_AD_INTERVALS = {
  overview: 'overviewinline_interval',
  sidemenu: 'sidemenu_interval'
};

export const VS_POPUP_INIT = {
  calledFrom: '',
  calledTo: '',
  calledFromDetails: [],
  calledToDetails: []
};

export const SITE_ACCESS_TYPES = {
  allow: 'allow', // Normal access
  allowAdmin: 'allow-admin', // Admin allowed to access site when other's access restricted
  restrict: 'restrict', // edit profile only
  expired: 'expired', // No access to event
  noAccess: 'no-access' // Session not allowed
};

export const ALLOWED_FEATURED_TYPES = {
  featured: 'featured',
  recommended: 'recommended',
  none: 'none'
};

export const ALLOWED_FLASH_POPUPS = {
  types: {
    privacy: 'privacy',
    appDownload: 'download',
    editProfile: 'editProfile'
  },
  privacyTypes: ['', 'all', 'required'],
  payload: {
    privacy: '',
    download: false,
    editProfile: false
  }
};

export const ALLOWED_RATINGS_DELAYS = {
  types: {
    '5_min': '5_min',
    '10_min': '10_min',
    '15_min': '15_min',
    onlyAfter: 'after_session',
    anyTime: 'anytime'
  },
  timeTypes: ['5_min', '10_min', '15_min', 'after_session'],
  intervals: {
    '5_min': 5,
    '10_min': 10,
    '15_min': 15
  }
};

export const SESSION_CALENDAR = {
  save: 'Save',
  reminder: 'Reminder'
};

/**
 * @property `display` and `cropper` are for render UI
 * @property `required` is for file dimension
 */
export const IMAGE_CROPPER_SIZES = {
  addPoll: {
    display: { height: 150, width: 150 },
    required: { height: 100, width: 100 },
    cropper: { height: 100, width: 100 }
  },
  myProfile: {
    display: { width: 150, height: 150 },
    required: { width: 200, height: 200 },
    cropper: { width: 150, height: 150 }
  },
  myProfileBanner: {
    display: {
      width: 382.514,
      height: 200,
      mobileWidth: 306,
      mobileHeight: 160
    },
    required: { width: 700, height: 366 },
    cropper: {
      width: 382.514 - 50,
      height: 200 - 50,
      mobileWidth: 306 - 50,
      mobileHeight: 160 - 50
    }
  },
  speaker: {
    display: { width: 160, height: 240 },
    required: { width: 320, height: 480 },
    cropper: { width: 125, height: 190 }
  },
  exhibitorLogo: {
    display: { width: 150, height: 150 },
    required: { width: 300, height: 300 },
    cropper: { width: 150, height: 150 }
  },
  exhibitorBanner: {
    display: { width: 307.6, height: 200 },
    required: { width: 566, height: 368 },
    cropper: { width: 307.6 - 50, height: 200 - 50 }
  },
  productImage: {
    display: { width: 150, height: 150 },
    required: { width: 100, height: 100 },
    cropper: { width: 50, height: 50 }
  }
};

export const MANDATORY_PROFILE_OPEN_TYPES = {
  req: 'required',
  always: 'always',
  none: 'none'
};

export const GAMIFICATION_CHALLENGE_VISIBILITY = {
  types: ['single', 'recurring', 'all'],
  single: 'single',
  recurring: 'recurring',
  all: 'all'
};

export const ALLOWED_PIN_ACTION_TYPES = {
  pin: 'pin',
  top: 'top',
  bottom: 'button',
  up: 'up',
  down: 'down',
  unpin: 'unpin'
};

export const ALLOWED_POST_ANALYTICS_TYPES = {
  // All screens
  screens: [
    'agenda',
    'attendees',
    'bookmarks',
    'chat',
    'chatlist',
    'exhibitor',
    'exhibitors',
    'exhibitorsdeal',
    'home',
    'news',
    'overview',
    'overviewinline',
    'schedules',
    'sidemenu',
    'speakers',
    'sponsor',
    'sponsors',
    'socialboost'
  ],
  screen: {
    agenda: 'agenda',
    attendees: 'attendees',
    bookmarks: 'bookmarks',
    chat: 'chat',
    chatList: 'chatlist',
    exhibitor: 'exhibitor',
    exhibitors: 'exhibitors',
    exhibitorsDeal: 'exhibitorsdeal',
    home: 'home',
    news: 'news',
    overview: 'overview',
    overviewInLine: 'overviewinline',
    schedules: 'schedules',
    sidemenu: 'sidemenu',
    speakers: 'speakers',
    sponsor: 'sponsor',
    sponsors: 'sponsors',
    socialBoost: 'socialboost'
  },
  // All types
  types: ['entry', 'search', 'ad_view', 'ad_click'],
  type: {
    entry: 'entry',
    search: 'search',
    adView: 'ad_view',
    adClick: 'ad_click'
  }
};

export const ALLOWED_EXHIBITOR_GI_TYPES = {
  photos: 'PHOTOS',
  videos: 'VIDEOS',
  documents: 'DOCUMENTS',
  coupons: 'COUPONS',
  deals: 'DEALS',
  boothPersonnel: 'ASSOCIATED_USER'
};

export const ALLOWED_SESSION_CHECKED_IN_TYPES = {
  checkedIn: 'checked-in',
  checkedOut: 'checked-out',
  open: 'open-for-self-check-in',
  self: 'selfcheckin'
};
